import { ContentCategory } from "./types";

export const getContentPath = (
  category: ContentCategory,
  slug: string
) => {
  if (category === "latestNews") {
    return `/latest-news/${slug}`;
  }
  return `/ministries/${slug}`;
};
